
export const pages = {
    'HOME': 'home',
    'SALEM': 'salem',
    'METHUEN': 'methuen',
    'RATES': 'rates',
};